<template>
    <!-- 派对订单收款组件 -->
    <div>
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        title="归档"
        :visible="visible"
        @cancel="cancel"
        :width="650"
        :bodyStyle="{padding: 0}"
        >
            <a-spin :spinning="spinning"> 
                <div class="pt16 pl16 pr16">
                    <a-row class="mt16">
                        <a-col :span="12">订单号：{{detailData.id}}</a-col>
                        <a-col :span="12">派对日期：{{detailData.partyDate}}</a-col>
                    </a-row>
                    <a-row class="mt16">
                        <a-col :span="12">派对门店：{{detailData.shopName}}</a-col>
                        <a-col :span="12">客户名称：{{detailData.customerName}}</a-col>
                    </a-row>
                    <a-row class="mt16">
                        <a-col :span="12">客户手机号：{{detailData.customerPhone}}</a-col>
                        <a-col :span="12">派对负责人：{{detailData.partyStaff}}</a-col>
                    </a-row>
                    <a-alert class="mt16" :show-icon="false" banner>
                        <template slot="message">
                            <div class="text-center">
                                <a-row class="mb8">
                                    <a-col :span="8">预售金额（元）</a-col>
                                    <a-col :span="8">实收金额（元）</a-col>
                                    <a-col :span="8">剩余预计应收金额（元）</a-col>
                                </a-row>
                                <a-row>
                                    <a-col :span="8">{{detailData.totalPresell | myToFixed2 | thousandFormat}}</a-col>
                                    <a-col :span="8">{{detailData.payment | myToFixed2 | thousandFormat}}</a-col>
                                    <a-col :span="8" class="text-fail">{{(detailData.totalPresell - detailData.payment) | myToFixed2 | thousandFormat}}</a-col>
                                </a-row>
                            </div>
                        </template>
                    </a-alert>
                </div>
                <a-divider class="mt16 mb16"></a-divider>
                <a-form :form="form">
                    <a-table class="ml24 mr24 mb24" bordered  :dataSource="dataSource" :columns="columns" :pagination="false" :rowKey="(record, index) => index">
                        <template slot="presell" slot-scope="key, row, index">
                            {{key | myToFixed2 | thousandFormat}}
                        </template>
                        <template slot="costKey" slot-scope="key, row, index">
                            <a-form-item class="no-margin_bottom">
                                <a-input-number style="width: 100%;" v-decorator="[key, {rules: [{required: true, message: '请输入'}, {pattern: /^(\d*)([.]{1}\d{1,2}?)?$/, message: '请输入大于等于0的数字'}]}]" placeholder="请输入大于等于0的数字"></a-input-number>
                            </a-form-item>
                        </template>
                        <template slot="paymentKey" slot-scope="key, row, index">
                            <a-form-item class="no-margin_bottom">
                                <a-input-number style="width: 100%;" v-decorator="[key, {rules: [{required: true, message: '请输入'}, {pattern: /^(\d*)([.]{1}\d{1,2}?)?$/, message: '请输入大于等于0的数字'}]}]" placeholder="请输入大于等于0的数字"></a-input-number>
                            </a-form-item>
                        </template>
                    </a-table>
                    <a-form-item label="备注" :label-col="{span: 4}" :wrapper-col="{span: 20}">
                        <a-textarea style="width: 90%; resize: none; height: 80px;" v-decorator="['remark', {rules: [{pattern: /^.{10,50}$/, message: '请输入10~50字'}]}]" placeholder="请输入（10~50字）"></a-textarea>
                    </a-form-item>
                </a-form>
            </a-spin>
            <template slot="footer">
                <a-row>
                    <a-col :span="12" class="text-left" style="line-height: 32px;"><span class="text-fail">*</span>订单归档后无法更改，请确认后归档</a-col>
                    <a-col :span="12" class="text-right">
                        <a-button @click="cancel">取消</a-button>
                        <a-popconfirm
                            title="归档后订单无法再更改，请确认是否归档？"
                            ok-text="确认"
                            cancel-text="取消"
                            @confirm="ok"
                        >
                            <a-button type="primary" :loading="confirmLoading">确认归档</a-button>
                        </a-popconfirm>
                    </a-col>
                </a-row>
            </template>
        </a-modal>
    </div>
</template>

<script>
    const columns = [
    {
        title: "商品分类",
        dataIndex: "category",
        width: "25%"
    },
    {
        title: "预售金额",
        dataIndex: "presell",
        scopedSlots: { customRender: 'presell' },
        width: "25%"
    },
    {
        title: "成本价",
        dataIndex: "costKey",
        scopedSlots: { customRender: 'costKey' },
        width: "25%"
    },
    {
        title: "实收金额",
        dataIndex: "paymentKey",
        scopedSlots: { customRender: 'paymentKey' },
        width: "25%"
    }]
    export default {
        name: "partyOrderFile",
        zh: "派对订单归档",
        components: {},
        props: {
        },
        data() {
            return {
                columns,
                dataSource: [],
                visible: false,
                spinning: false,
                confirmLoading: false,
                detailData: {},
                orderId: null
            }
        },
        computed: {},
        watch: {
            visible(val) {

            }
        },
        methods: {
            open(orderId) {
                this.visible = true;
                this.orderId = orderId;
                this.getDetail();
            },
            ok() {
                this.form.validateFields((errors, values) => {
                    if (Boolean(errors) || this.confirmLoading) {
                        return false;
                    };
                    this.confirmLoading = true;
                    this.$api.order.partyOrderArchive({
                        body: {
                            ...values,
                            orderId: this.orderId,
                        }
                    }).then(res => {
                        this.$message.success('操作成功！');
                        this.confirmLoading = false;
                        this.cancel();
                    }).catch(err => {
                        this.confirmLoading = false;
                    });
                });
            },
            cancel() {
                this.visible = false;
                this.$emit('cancel');
            },
            /**
             * @func getDetail 获取订单详情
             */
            getDetail() {
                this.spinning = true;
                this.$api.order.partyOrderDetail({
                    params: {
                        id: this.orderId
                    }
                }).then(res => {
                    this.dataSource = [
                        {
                            category: '门票',
                            presell: res.ticketPresell,
                            costKey: 'ticketCost',
                            paymentKey: 'ticketPayment'
                        },
                        {
                            category: '餐饮',
                            presell: res.cateringPresell,
                            costKey: 'cateringCost',
                            paymentKey: 'cateringPayment'
                        },
                        {
                            category: '装饰',
                            presell: res.decoratePresell,
                            costKey: 'decorateCost',
                            paymentKey: 'decoratePayment'
                        },
                        {
                            category: '增值服务',
                            presell: res.servicePresell,
                            costKey: 'serviceCost',
                            paymentKey: 'servicePayment'
                        }
                    ];
                    this.detailData = res;
                    this.spinning = false;
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        updated() {},
        mounted() {},
    };
</script>

<style lang="scss">
</style>
